<template>
  <v-card>
    <v-card-text>
      <v-data-table
        dense
        :headers="headers"
        :items="partsItems"
        hide-default-footer
        item-key="key"
        :items-per-page="-1"
      >
        <template v-slot:item.eotRequested="{ item }">
          <span class="nowrap" v-if="item.eotRequested">
            <v-icon class="primary--text" small>mdi-calendar-clock</v-icon>
            {{item.eotRequested}}
          </span>
        </template>
        <template v-slot:item.eotAgreed="{ item }">
          <span class="nowrap" v-if="item.eotAgreed">
            <v-icon class="success--text" small>mdi-timetable</v-icon>
            {{item.eotAgreed}}
          </span>
        </template>
        <template v-slot:item.estimatedValue="{ item }">
          <span class="nowrap" v-if="item.estimatedValueCents">
            <v-icon class="orange--text" small>mdi-approximately-equal</v-icon>
            {{item.estimatedValueCents | formatCurrency({ key: item.currency, value: 1 }) }}
          </span>
        </template>
        <template v-slot:item.originalValue="{ item }">
          <span class="nowrap" v-if="item.originalValueCents">
            <v-icon class="primary--text" small>mdi-tag</v-icon>
            {{item.originalValueCents | formatCurrency({ key: item.currency, value: 1 }) }}
          </span>
        </template>
        <template v-slot:item.agreedValue="{ item }">
          <span class="nowrap" v-if="item.agreedValueCents">
            <v-icon class="success--text" small>mdi-handshake</v-icon>
            {{item.agreedValueCents |formatCurrency({ key: item.currency, value: 1 }) }}
          </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { getLocalizationContext } from '@/helpers/translations'

export default {
  name: 'VariationsPartsTable',
  props: {
    parts: Array,
    reporter: String,
    isMultiCurrency: Boolean
  },
  data () {
    return {
      headers: [
        { text: this.$t(getLocalizationContext(this.isMultiCurrency) + '.name'), value: 'name', sortable: false },
        { text: this.$t('variation.estimatedValue'), value: 'estimatedValue', sortable: false },
        { text: this.$t('variation.originalValue'), value: 'originalValue', sortable: false },
        { text: this.$t('variation.agreedValue'), value: 'agreedValue', sortable: false },
        { text: this.$t(`variation.eotRequested.${this.reporter}`), value: 'eotRequested', sortable: false },
        { text: this.$t(`variation.eotAgreed.${this.reporter}`), value: 'eotAgreed', sortable: false }
      ]
    }
  },
  computed: {
    partsItems () {
      return this.parts.map(i => {
        return {
          ...i,
          ...i.variationPart,
          variationPart: undefined
        }
      })
    }
  }
}
</script>
